/*
//Salesforce test sandbox environment details:
export const SALESFORCE_API = 'https://test.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8'
export const SALESFORCE_OID = '00Dq0000000EaL4';
*/

import {ContactUsFormValues} from "../../common/models/common.models";

export const SALESFORCE_OID = '00D00000000hfJ4';
export const SALESFORCE_API = 'https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8';

export const SALESFORCE_FORM_NAME = 'TolunaStart License Request';

export enum licenseRequestFormFieldNames {
    COUNTRY = '00N00000006yoDA',
    INDUSTRY = '00N80000004yRyN',
    STATE = '00N00000006yoD5',
    LICENSE_TYPE = '00N3n000003rFMF',
}

export const getFormFieldDescriptors = (formName: string, data: ContactUsFormValues) => {
    const { firstName, lastName, companyName, email, phone, helpDescription, helpCategory, industry } = data;
    return [
        { name: 'oid', value: SALESFORCE_OID },
        { name: 'retURL', value: '' },
        { name: 'first_name', value: firstName },
        { name: 'last_name', value: lastName },
        { name: 'email', value: email },
        { name: 'phone', value: phone },
        { name: 'company', value: companyName },
        { name: 'description', value: helpDescription },
        {
            id: [licenseRequestFormFieldNames.LICENSE_TYPE],
            name: [licenseRequestFormFieldNames.LICENSE_TYPE],
            value: helpCategory,
        },
        { id: [licenseRequestFormFieldNames.INDUSTRY], name: [licenseRequestFormFieldNames.INDUSTRY], value: industry },
        { name: 'lead_source', value: formName ?? SALESFORCE_FORM_NAME },
    ];
};
